import { createRoot } from "react-dom/client";
import App from './App';
import "./index.css";
import { installExtensionErrorSuppressor } from "./lib/suppressExtensionErrors";

installExtensionErrorSuppressor();

createRoot(document.getElementById("root")!).render(<App />);
